<template>
	<v-container fluid class="pt-3 mb-1">
		<v-snackbar v-model="reviewDeletedNotif" top>
			Check In Deleted
			<v-btn color="pink" flat @click="reviewDeletedNotif = false">
				Close
			</v-btn>
		</v-snackbar>

		<v-layout v-if="showFilterBar" row wrap class="mb-1">
			<v-flex xl3 lg4 md6 sm6 xs12 class="pr-3">	
				<v-text-field v-debounce:300ms="updateSearch" ref="focusAfterTagSelector" append-icon="search" label="Search Employees" autofocus="" background-color="#fff"></v-text-field>
			</v-flex>
			<v-flex xl3 lg4 md6 sm6 xs12 class="pr-3">
				<tag-selector :options="tagList"
							:selectedOptions="selectedTags"
							:isMatchAll="matchAllTags"
							placeholder="Enter Tag"
							@on-selected-tags-change="updateSelectedTags"
							@on-match-all-tags-change="updateMatchAllTags"
							@on-leave="onLeaveTagSelector"></tag-selector>
			</v-flex>
		</v-layout>

		<v-layout row wrap>
			<v-flex lg12>
				<v-card class="mb-4">
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">Pending Check Ins</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>

					<v-data-table disable-initial-sort :headers="headers" :items="filteredPendingCheckIns" :loading="checkIns_loading" hide-actions class="elevation-1">
						<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

						<template slot="items" slot-scope="props">
							<tr>
								<td class="text-xs-left">	
									<router-link :to="{ name: 'employee', params: { id: props.item.employeeId } }"><span :class="{ highlight: props.item.isLoggedInEmployee }">{{ props.item.employee }}</span></router-link>
								</td>
								<td class="text-xs-left">
									<router-link :to="{ name: 'employee', params: { id: props.item.reviewerId } }"><span>{{ props.item.reviewer }}</span></router-link>							
								</td>
								<td class="text-xs-left">
									<AppDate :date="props.item.createdDateUtc" />
								</td>
								<td class="text-xs-left">
									<AppDate :date="props.item.dueDateUtc" showDate nullDate="N/A" />
								</td>
								<td class="text-xs-left">
									<div v-if="props.item.status === 'Complete'" style="color: #388E3C">
										<div v-if="props.item.updatedDateUtc != null">
											Submitted <AppDate :date="props.item.updatedDateUtc" />
										</div>
										<div v-else>
											Complete
										</div>										
									</div>
									<div v-else>
										<div v-if="props.item.updatedDateUtc != null" style="color: #fb8c00;">
											Draft saved <AppDate :date="props.item.updatedDateUtc" />
										</div>
										<div v-else>
											{{props.item.status}}
										</div>				
									</div>
								</td>
								<td class="text-xs-right px-0" style="width: 1px;">
									<v-btn small :class="{primary: props.item.isLoggedInEmployee && props.item.status !== 'Complete'}" @click="view(props.item)">{{getViewButtonText(props.item)}}</v-btn>
								</td>
								<td class="justify-center pl-0 pr-2" style="width: 1px;">
									<v-icon v-if="loggedInEmployee != null && loggedInEmployee.isAdmin" small @click="deleteReview(props.item)">
										delete
									</v-icon>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-card>
			</v-flex>

			<v-flex lg12>
				<v-card class="mb-4">
					<v-toolbar flat dense class="success" dark>
						<v-toolbar-title class="subheading">Completed Check Ins</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>

					<v-card-text>
						<v-flex md3>
							<v-select v-model="completedListFilter" :items="completedListFilterOptions" item-text="text" item-value="value" label="Period" required></v-select>
						</v-flex>
					</v-card-text>

					<v-data-table disable-initial-sort :headers="headers" :items="filteredCompletedCheckIns" :loading="checkIns_loading" hide-actions class="elevation-1">
						<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

						<template slot="items" slot-scope="props">
							<tr>
								<td class="text-xs-left">	
									<router-link :to="{ name: 'employee', params: { id: props.item.employeeId } }"><span :class="{ highlight: props.item.isLoggedInEmployee }">{{ props.item.employee }}</span></router-link>
								</td>
								<td class="text-xs-left">
									<router-link :to="{ name: 'employee', params: { id: props.item.reviewerId } }"><span>{{ props.item.reviewer }}</span></router-link>							
								</td>
								<td class="text-xs-left">
									<AppDate :date="props.item.createdDateUtc" />
								</td>
								<td class="text-xs-left">
									<AppDate :date="props.item.dueDateUtc" showDate nullDate="N/A" />
								</td>
								<td class="text-xs-left">
									<div v-if="props.item.status === 'Complete'" style="color: #388E3C">
										<div v-if="props.item.updatedDateUtc != null">
											Submitted <AppDate :date="props.item.updatedDateUtc" />
										</div>
										<div v-else>
											Complete
										</div>										
									</div>
									<div v-else>
										<div v-if="props.item.updatedDateUtc != null" style="color: #fb8c00;">
											Draft saved <AppDate :date="props.item.updatedDateUtc" />
										</div>
										<div v-else>
											{{props.item.status}}
										</div>				
									</div>
								</td>
								<td class="text-xs-right px-0" style="width: 1px;">
									<v-btn small :class="{primary: props.item.isLoggedInEmployee && props.item.status !== 'Complete'}" @click="view(props.item)">{{getViewButtonText(props.item)}}</v-btn>
								</td>
								<td class="justify-center pl-0 pr-2" style="width: 1px;">
									<v-icon v-if="loggedInEmployee != null && loggedInEmployee.isAdmin" small @click="deleteReview(props.item)">
										delete
									</v-icon>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-card>
			</v-flex>

				<v-footer color="" app height="55">
						<v-spacer></v-spacer>
						<v-btn @click="onAddClick" color="primary"> <v-icon dark class="mr-2">add</v-icon> New Check In</v-btn>
					</v-footer>
			
		</v-layout>
	</v-container>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import TagSelector from '@/components/tags/TagSelector';
	import moment from 'moment';

	export default {
		components: {
			TagSelector
		},
		props: {
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				checkInsPending: 'checkIns/checkInsPendingList',
				checkInsCompleted: 'checkIns/checkInsCompletedList',
				tagList: 'tags/employeeTagList',
				hasUnderlingsOrAdmin: 'hasUnderlingsOrAdmin'
			}),
			...mapState({
				checkIns_loading: state => state.checkIns.checkIns_loading
			}),
			headers() {
				let h = [
					{ text: 'Employee', value: 'employee' },
					{ text: 'Reviewer', value: 'reviewer' },
					{ text: 'Created', value: 'createdDateUtc' },
					{ text: 'Due Date', value: 'dueDateUtc' },
					{ text: 'Status', value: 'status' },
				];
				h.push({ text: '', value: 'actions', sortable: false });
				return h;
			},
			filteredEmployeeIds() {
				const filterOptions = {
					search: this.search,
					tags: this.selectedTags,
					matchAllTags: this.matchAllTags
				};
				return this.$_getFilteredEmployeeIds(this.loggedInEmployee, filterOptions);
			},
			filteredPendingCheckIns() {
				return this.checkInsPending.filter(x => this.filteredEmployeeIds.includes(x.employeeId) || this.filteredEmployeeIds.includes(x.reviewerId));
			},
			filteredCompletedCheckIns() {
				let filtered = this.checkInsCompleted.filter(x => this.filteredEmployeeIds.includes(x.employeeId) || this.filteredEmployeeIds.includes(x.reviewerId));

				return filtered.filter(x => {
					if (x.dueDateUtc == null) return false;

					switch(this.completedListFilter) {
						case 0:
							return x.dueDateUtc > moment.utc() || (moment.utc(x.dueDateUtc).year() === new Date().getUTCFullYear() && moment.utc(x.dueDateUtc).month() === new Date().getUTCMonth());
						case 1: 
							return x.dueDateUtc > moment.utc() || moment.utc().diff(x.dueDateUtc, 'months') <= 3;
						case 2: 
							return x.dueDateUtc > moment.utc() || moment.utc().diff(x.dueDateUtc, 'months') <= 6;
						case 3: 
							return x.dueDateUtc > moment.utc() || moment.utc(x.dueDateUtc).year() === new Date().getUTCFullYear();
						case 4: 
							return true;
						default: 
							return true;
					}
				});
			},
			showFilterBar() {
				return this.hasUnderlingsOrAdmin;
			},
		},
		data() {
			return {
				reviewDeletedNotif: false,
				search: '',
				selectedTags: [],
				matchAllTags: false,
				completedListFilter: 3,
				completedListFilterOptions: [
					{ value: 0, text: 'This month' },
					{ value: 1, text: 'Last 3 months' },
					{ value: 2, text: 'Last 6 months' },
					{ value: 3, text: new Date().getUTCFullYear() },
					{ value: 4, text: 'All time' },
				],
			};
		},
		methods: {
			onAddClick() {
				this.$router.push(`/checkIn/create/`);
			},
			async deleteReview(item) {
				if (confirm(`Are you sure you want to delete this Check In?`)) {
					try {
						let result = await this.$store.dispatch('checkIns/delete', item);
						this.reviewDeletedNotif = true;
					} catch(err) {
						console.error('Error deleting Check In');
					}
				}
			},
			view(item) {
				this.$router.push(`/checkIn/${item.id}/`);
			},
			getViewButtonText(item) {
				if(item.isLoggedInEmployee && item.status !== "Complete") 
					return "Fill out Check In";			
				else 
					return "View";
			},
			updateSelectedTags(newSelectedTags) {
				this.selectedTags = newSelectedTags;
			},
			updateMatchAllTags(newMatchAll) {
				this.matchAllTags = newMatchAll;
			},
			onLeaveTagSelector() {
				this.$refs.focusAfterTagSelector.focus();
			},
			updateSearch(val) {
				this.search = val;
			}
		},
		created() {
			this.$store.dispatch('setPageTitle', `Check Ins`);
		}
	};
</script>

<style>
	.complete td:first-child {
		border-left: solid 6px #43A047;
	}
</style>
